import { CSSProperties, ReactElement, useState, useEffect } from "react";
import { ListView } from "../common/ListView";
import styles from "./BottomDescList.module.css";

export interface BottomDescListProps {
    contentWidth: number;
    containerWidth: number;
    col: number;
    data: any;
    titStyle?: CSSProperties | undefined;
    desStyle?: CSSProperties | undefined;
}

export interface BottomDescColProps {
    contentWidth: number;
    src: string;
    onclick?: () => void | undefined;
    tit: string;
    des: string[];
    titStyle?: CSSProperties | undefined;
    desStyle?: CSSProperties | undefined;
}

/**
 * @author sukim91
 * @date 2022-09-21 13:38:25
 * @remark 가격 정책 컴포넌트 내 리스트
 * @param props BottomDescListProps
 * @props BottomDescListProps
 *      containerWidth: 외부 컨테이너 너비(px) (required)
 *      contentWidth: column 하나의 너비(px) (required)
 *      col: 행 개수 (required)
 *      src: 이미지 경로 (required)
 *      onclick: 클릭 시 실행되는 함수
 *      tit: 설명 타이틀 (required)
 *      des: 설명 내용(리스트) (required)
 *      titStyle: 컨텐츠 내부 타이틀 스타일
 *      desStyle: 컨텐츠 내부 설명 스타일
 * @returns <ul><li>
 */
export function BottomDescList(props: BottomDescListProps) {

    const BottomDescCols = (props: BottomDescColProps) => {
        const list = props.des.map((item, index) => {
            return <li key={index} style={!props.desStyle ? {} : { ...props.desStyle }} dangerouslySetInnerHTML={{ __html: item }}></li>;
        });

        const input = (props: BottomDescColProps) => {
            if (!props.onclick) {
                return <input type="image" src={props.src} alt="" />;
            } else {
                return <input type="image" src={props.src} onClick={props.onclick} alt="" />;
            }
        };

        return (
            <div className={styles.col}>
                <i>{input(props)}</i>
                <p className={styles.tit} style={!props.titStyle ? {} : { ...props.titStyle }}>
                    {props.tit}
                </p>
                <div className={styles.desc}>
                    <ul>{list}</ul>
                </div>
            </div>
        );
    };

    let col, row;

    const containerWidth = Math.ceil(props.contentWidth * props.col);

    if (props.containerWidth < containerWidth) {
        col = Math.floor(props.containerWidth / props.contentWidth);
    } else {
        col = props.col;
    }

    row = Math.ceil(props.data.length / col);

    const createListItems = (data: [], row: number, col: number) => {
        const arr = new Array();

        for (let i = 0; i < row; i++) {
            const start = i * col;
            const end = (i + 1) * col;
            const item = i + 1 <= row ? data.slice(start, end) : data.slice(start);

            arr.push(item);
        }

        return arr;
    };

    const bottomDescListItems = createListItems(props.data, row, col);

    const list = new Array<ReactElement>();

    for (let i = 0; i < row; i++) {
        list.push(
            <div className={styles.row}>
                <ListView
                    data={bottomDescListItems[i]}
                    //renderItem={renderItem}
                    renderItem={(item, index) => (
                        <BottomDescCols
                            key={index}
                            contentWidth={props.contentWidth}
                            src={item.src}
                            onclick={item.onclick}
                            tit={item.tit}
                            des={item.des}
                            titStyle={props.titStyle}
                            desStyle={props.desStyle}
                        />
                    )}
                />
            </div>
        );
    }

    return <>{list}</>;
}

export default BottomDescList;
